import { Route, Switch } from 'react-router';
import CreateStudent from './create';
import EditStudent from './edit';
import ViewCaseload from './view';
import ApproveCaseload from './approve';
import SearchStudents from './search';
import CaseloadSearch from './caseloadSearch';
import Duplicates from './duplicates';
import ManualMerge from './manualMerge';

const Caseloads = () => {
  return (
    <Switch>
      <Route exact path='/caseload' component={ViewCaseload} />
      <Route exact path='/caseload/new' component={CreateStudent} />
      <Route exact path='/caseload/search' component={SearchStudents} />
      <Route exact path='/caseload/searchCaseloads' component={CaseloadSearch} />
      <Route exact path='/caseload/approve' component={ApproveCaseload} />
      <Route exact path='/caseload/duplicates' component={Duplicates} />
      <Route exact path='/caseload/manualmerge' component={ManualMerge} />
      <Route exact path='/caseload/:id' component={EditStudent} />
    </Switch>
  );
};

export default Caseloads;
